import React from 'react';
import { Controller, get, useFormContext } from 'react-hook-form';
import Dropdown from './Dropdown';

const ControlledDropdown = ({
  label,
  options = [],
  placeholder = 'Выберите...',
  disabled = false,
  isClearable = false,
  isSearchable = true,
  className = '',
  valkey = 'value',
  optkey = 'label',
  optkey2,
  emptyMessage = 'Нет доступных опций',
  name,
  rules,
  defaultValue = null,
  ...restProps
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const error = get(errors, name);

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      defaultValue={defaultValue ?? ''}
      render={({ field }) => {
        return (
          <>
            <Dropdown
              label={label}
              className={className}
              value={field.value}
              onChange={field.onChange}
              options={options}
              placeholder={placeholder}
              disabled={disabled}
              isClearable={isClearable}
              isSearchable={isSearchable}
              valkey={valkey}
              optkey={optkey}
              optkey2={optkey2}
              emptyMessage={emptyMessage}
              hasError={Boolean(error)}
              {...restProps}
            />

            {error && <span className="block text-xs text-red-500 mt-1 ml-2">{error.message}</span>}
          </>
        );
      }}
    />
  );
};

export default ControlledDropdown;
